/**
 *
 */
export default {
  LATE_FROM: 300, // 5 min
  VERY_LATE_FROM: 900, // 15 min - without timer
  VERY_LATE_FROM_TIMER: 0, // countdown over
  CHANGE_TIME: 32, // 32 seconds
};
